const PUBLIC_JOB_POSITION_BASE_URL = '/apply';

export const PUBLIC_JOB_POSITION_LINKS = {
    apply: (jobPositionId: number | string) =>
        `${PUBLIC_JOB_POSITION_BASE_URL}/${jobPositionId}`
};
